import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const title: AnswerPathTreeNode = { path: 'title', nodeId: NodeIds.insuredTitle };
